import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { isTypeFn, withFragments } from '@sorare/core/src/gql';

import type { hasClaimableCommonGameMissions_managerProgression } from './__generated__/hasClaimableCommonGameMissions.graphql';

export const hasClaimableCommonGameMissions = withFragments(
  (
    managerProgression: Nullable<hasClaimableCommonGameMissions_managerProgression>
  ) => {
    const missions = managerProgression?.categories?.[0]?.categoryTasks.filter(
      isTypeFn('ManagerProgressionMission')
    );
    return !!missions?.length;
  },
  {
    managerProgression: gql`
      fragment hasClaimableCommonGameMissions_managerProgression on ManagerProgression {
        id
        categories(names: COMMON_GAME) {
          id
          categoryTasks {
            ... on ManagerProgressionMission {
              id
            }
          }
        }
      }
    ` as TypedDocumentNode<hasClaimableCommonGameMissions_managerProgression>,
  }
);
